import { render, staticRenderFns } from "./TextValidateInput.vue?vue&type=template&id=201c7f0a&scoped=true"
import script from "./TextValidateInput.vue?vue&type=script&lang=js"
export * from "./TextValidateInput.vue?vue&type=script&lang=js"
import style0 from "./TextValidateInput.vue?vue&type=style&index=0&id=201c7f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201c7f0a",
  null
  
)

export default component.exports